import { render, staticRenderFns } from "./VodPlayer.vue?vue&type=template&id=0e657d0e&scoped=true"
import script from "./VodPlayer.vue?vue&type=script&lang=js"
export * from "./VodPlayer.vue?vue&type=script&lang=js"
import style0 from "./VodPlayer.vue?vue&type=style&index=0&id=0e657d0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e657d0e",
  null
  
)

export default component.exports